import { NgClass, NgStyle, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

import { levelAttribute, MyuiLevel } from '../abstract/abstract.attribute';
import { MyuiComponent } from '../abstract/abstract.component';

import { type MyuiHintContext } from './hint.interface';

@Component({
  selector: 'myui-hint',
  templateUrl: 'hint.component.html',
  imports: [NgClass, NgStyle, NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyuiHint extends MyuiComponent {
  public override mSelector = 'myui-hint';

  public readonly text = input<string | undefined>();

  public readonly level = input(MyuiLevel.Info, { transform: levelAttribute });

  public readonly textTemplate = computed(() =>
    this._getTemplate<MyuiHintContext>('text'),
  );

  protected readonly _context = computed<MyuiHintContext>(() => {
    return {
      level: this.level(),
      $implicit: this.text(),
    };
  });
}
